import setFieldValue from "@iewcasia/Store/Handlers/CreateAccount/SetFieldValue";
import { CustomActions, CustomState } from "@iewcasia/Store/Reducers";
import { OwnProps, setRequestFormEffects, validateFieldBy } from "@iewcasia/Widgets/CreateAccount/FormBaseComponent";
import {
    getCountriesDataView,
    getCurrentCountries,
} from "@insite/client-framework/Store/Data/Countries/CountriesSelectors";
import { loadCurrentCountriesParameter } from "@insite/client-framework/Store/Data/Countries/Handlers/LoadCurrentCountries";
import translate from "@insite/client-framework/Translate";
import Select from "@insite/mobius/Select";
import * as React from "react";
import { connect, DispatchProp, ResolveThunks } from "react-redux";

const mapStateToProps = (state: CustomState) => {
    const countriesDataView = getCountriesDataView(state, loadCurrentCountriesParameter);
    return {
        shippingState: state.customCreateAccountForm.fieldValues.shippingState,
        previouslyPurchased: state.customCreateAccountForm.fieldValues.previouslyPurchased,
        shippingCountry: state.customCreateAccountForm.fieldValues.shippingCountry,
        countries: countriesDataView.value,
    };
};

const mapDispatchToProps = {
    setFieldValue,
};

type Props = OwnProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    DispatchProp<CustomActions>;

const shippingStateWidget: React.FC<Props> = ({
    previouslyPurchased,
    countries,
    shippingCountry,
    shippingState,
    setFieldValue: widgetSetFieldValue,
}) => {
    const label = translate("State");
    const isRequired = !previouslyPurchased || previouslyPurchased === "false";
    const hintText = "Select";
    const [shippingStateOptions, setshippingStateOptions] = React.useState<{ label: any; value: any }[]>([]);
    const [fieldErrorMessage, setFieldErrorMessage] = React.useState("");

    setRequestFormEffects(isRequired, shippingState, "shippingState", () =>
        validateFieldBy(isRequired, label, shippingState, setFieldErrorMessage),
    );

    const fieldChangeHandler = (event: React.ChangeEvent<HTMLSelectElement>) => {
        widgetSetFieldValue({ key: "shippingState", value: event.target.value });
    };

    React.useEffect(() => {
        if (shippingCountry) {
            widgetSetFieldValue({ key: "shippingState", value: "" });
            const states = countries?.find?.((x: any) => x.name === shippingCountry)?.states;
            setshippingStateOptions(states?.map?.((x: any) => ({ label: x.name, value: x.name })) || []);
        }
    }, [shippingCountry]);

    return (
        <Select
            label={label}
            required={isRequired}
            value={shippingState || ""}
            error={fieldErrorMessage}
            onChange={fieldChangeHandler}
            placeholder={hintText || ""}
        >
            <option value="" {...(isRequired && { disabled: true })}>
                {translate(hintText)}
            </option>
            {shippingStateOptions.map((shippingState: any) => (
                <option key={shippingState.value} value={shippingState.name}>
                    {shippingState.label}
                </option>
            ))}
        </Select>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(shippingStateWidget);
